import React from 'react';
import { FirstbornFigure } from './FirstbornFigure';
import { MiddleChildFigure } from './MiddleChildFigure';
import { YoungestFigure } from './YoungestFigure';
import { CabooseFigure } from './CabooseFigure';
import { OnlyChildFigure } from './OnlyChildFigure';
import type { SiblingRole } from '../../types/snak';
interface SiblingFigureProps {
  role: SiblingRole;
  className?: string;
}
export function SiblingFigure({
  role,
  className = ''
}: SiblingFigureProps) {
  if (role === 'firstborn') return <FirstbornFigure className={className} data-id="element-72" data-mp="2uieww40822ze" />;
  if (role === 'middle') return <MiddleChildFigure className={className} data-id="element-73" data-mp="2ugkcqrwryewd" />;
  if (role === 'youngest') return <YoungestFigure className={className} data-id="element-74" data-mp="2zgos2ely53l0" />;
  if (role === 'caboose') return <CabooseFigure className={className} data-id="element-75" data-mp="349hwt2hf0bx3" />;
  return <OnlyChildFigure className={className} data-id="element-76" data-mp="26tc4c141upq4" />;
}